export default __webpack_public_path__ + "static/media/3.dab9bc09.png";